// extracted by mini-css-extract-plugin
export default {"root":"InvoiceMediaPreview-module__root","duration":"InvoiceMediaPreview-module__duration","buy":"InvoiceMediaPreview-module__buy","spoiler":"InvoiceMediaPreview-module__spoiler"};